module.exports = __webpack_public_path__ + "static/me-9428791bdc7a7ec6c3180b41f4e24a8f.jpg";